import React, { forwardRef } from 'react';
import { Button } from '@spothero/ui';
import { styles } from '../styles';
export const FilterCheckboxBase = forwardRef(({ children, onClick, isActive, testid, order, }, ref) => {
    return (<Button {...styles} order={order} ref={ref} _focus={{
            boxShadow: 'none',
            borderColor: isActive ? 'black' : 'accent',
        }} _active={{
            borderColor: isActive ? 'black' : 'accent',
        }} backgroundColor={isActive ? 'gray.light' : 'transparent'} borderColor={isActive ? 'black' : 'accent'} data-testid={testid} onClick={onClick} key={`FilterCheckboxBase-${isActive ? 'active' : 'inactive'}`}>
                {children}
            </Button>);
});
FilterCheckboxBase.displayName = 'FilterCheckboxBase';
